﻿import bulmaCollapsible from '@creativebulma/bulma-collapsible';

document.addEventListener('DOMContentLoaded', () => {
    const bulmaCollapsibleInstances = bulmaCollapsible.attach('.is-collapsible:not(.is-collapsible-vue)');

    bulmaCollapsibleInstances.forEach(bulmaCollapsibleInstance => {
        if (bulmaCollapsibleInstance.element.id === 'mainSearch') {
            const $form = bulmaCollapsibleInstance.element;
            const $input = $form.querySelector('input');
            const $button = $form.querySelector('button.is-secondary');
            let buttonClicked = false;
            $button.addEventListener('click', (event) => {
                buttonClicked = true;
            });
            $input.addEventListener('blur', () => {
                setTimeout(() => {
                    if (!buttonClicked) {
                        bulmaCollapsibleInstance.collapse();
                    }
                }, 500);
            });
            bulmaCollapsibleInstance.on('after:expand', () => {
                $input.focus();
            });
            $form.addEventListener('submit', function (e) {
                e.preventDefault();
                if ($input.value.trim() !== '') {
                    $form.submit();
                } else {
                    $input.focus();
                }
            });
        }
    });
});